export const constants = {
    isTouch: "ontouchstart" in window ? function () {
        document.body.classList.add("touch");
        return true;
    }() : function () {
        document.body.classList.add("no-touch");
        return false;
    }(),
    body: $("body"),
    isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? document.body.classList.add("safari") : ''
};


// WEBPACK FOOTER //
// ./assets/js/modules/module.js